import ReferralScheduleStatusTypeEntity from '../entities/ReferralScheduleStatusType.Entity';
import { apiGet, apiPost } from '../support/helpers/ApiConnection.Helper';

export default function getReferralScheduleStatusTypes(abortSignal: AbortSignal): Promise<Array<ReferralScheduleStatusTypeEntity>> {    
    return apiGet<Array<ReferralScheduleStatusTypeEntity>>('/referral-schedule-status-types/get-all',abortSignal);
}